__turbopack_context__.v({
  "content": "IHcjTW_content",
  "description": "IHcjTW_description",
  "description-content": "IHcjTW_description-content",
  "desktop-only": "IHcjTW_desktop-only",
  "mobile-only": "IHcjTW_mobile-only",
  "research-description": "IHcjTW_research-description",
  "research-descriptions": "IHcjTW_research-descriptions",
  "root": "IHcjTW_root",
});
